import { useCallback, useReducer } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SATRT_LOADING: 'SATRT_LOADING',
  SET_ACTIVITY_LOG: 'SET_ACTIVITY_LOG',
  FETCH_ERROR: 'FETCH_ERROR',
  RELOAD_DATE: 'RELOAD_DATE',
}

const initialState = {
  meta: {
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    total: 0,
  },
  isLoading: false,
  data: [],
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SATRT_LOADING:
      return {
        ...state,
        isLoading: true,
      }
    case ActionType.SET_ACTIVITY_LOG:
      return {
        ...state,
        isLoading: false,
        meta: action.payload.meta,
        data: action.payload.data,
      }
    case ActionType.FETCH_ERROR:
      return {
        ...state,
        isLoading: false,
      }
    case ActionType.RELOAD_DATE:
      return {
        ...state,
        meta: action.payload,
        isLoading: true,
      }

    default:
      return state
  }
}

export default function useActivity() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const handleAlertError = useCallback(() => {
    dispatch({ id: ActionType.FETCH_ERROR })
    return commonDispatch(
      MessageAlert.showError({
        message: formatMessage({
          id: 'error.general',
        }),
      }),
    )
  }, [commonDispatch, formatMessage])

  const fetchActivity = useCallback(
    ({ subscriberId, params }) => {
      effects.apis
        .getActivity({ subscriberId, params })
        .then((response) => {
          dispatch({ type: ActionType.SET_ACTIVITY_LOG, payload: response })
        })
        .catch((error) => handleAlertError(error))
    },
    [handleAlertError],
  )

  const handleFetchActivity = ({ subscriberId }) => {
    dispatch({ type: ActionType.SATRT_LOADING })
    fetchActivity({ subscriberId, params: state.meta })
  }

  const updatePage = ({ page, limit, subscriberId }) => {
    const meta = {
      ...state.meta,
      currentPage: page,
      perPage: limit,
    }
    dispatch({ type: ActionType.RELOAD_DATE, payload: meta })
    fetchActivity({
      subscriberId,
      params: meta,
    })
  }

  return {
    state,
    handleFetchActivity,
    updatePage,
  }
}
